import axios from "../utils/fetch";
/**
 * 获取facebook request token
 * https://post-test.apphi.com/api/docs/#!/social_auth/Social_Auth_get_twitter_request_token
 * @param callback_url 回调地址
 */
export function requestToken({ callback_url }) {
  return axios.get(`social_auth/twitter/request_token`, {
    params: { callback_url },
  });
}
/**
 * 获取facebook access token
 * https://post-test.apphi.com/api/docs/#!/social_auth/Social_Auth_get_twitter_access_token
 * @param oauth_verifier 回调地址
 */
export function accessToken({ oauth_verifier }) {
  return axios.post(`social_auth/twitter/access_token`, {
    oauth_verifier,
  });
}
